import { render, staticRenderFns } from "./Branches.html?vue&type=template&id=132068a4&external"
import script from "./Branches.js?vue&type=script&lang=js&external"
export * from "./Branches.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports